import React, {useMemo, useState} from "react";
import styled from "styled-components";
import TableComponent from "../../common/components/TableComponent";
import EditDialogComponent from "../editDialog";
import {SearchBox, SearchIcon, SearchInput} from "../products/styles";

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
const ComponentHeader = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: max-content;
    justify-content: space-between;
`;
const SearchContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    font-size: 22px;
    align-items: center;
    gap: 20px;
`;

function UsersComponent(props) {
    const {state, refreshList} = props;
    const [searchText, setSearchText] = useState('')

    const filteredList = useMemo(() => searchText && state.usersList ?
        state.usersList.filter(data => data.name?.toLowerCase().includes(searchText)
            || data.shopName?.toLowerCase().includes(searchText))
        : state.usersList || [], [state.usersList, searchText])

    return (
        <MainContainer>
            <ComponentHeader>
                <SearchContainer>
                    Users
                    <SearchBox>
                        <SearchInput placeholder="Search" onChange={e => setSearchText(e.target.value)}/>
                        <SearchIcon src="/images/search-icon.svg"/>
                    </SearchBox>
                    {filteredList?.length ? <div>{filteredList?.length} Users</div> : ''}
                </SearchContainer>
            </ComponentHeader>
            <TableComponent.Table cellpadding="0" cellspacing="0">
                <TableComponent.TableHead>
                    <TableComponent.HeadColumn>Name</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Shop Name</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Phone</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Subscription</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>OTP</TableComponent.HeadColumn>
                    {/*<TableComponent.HeadColumn>Active</TableComponent.HeadColumn>*/}
                    <TableComponent.HeadColumn>Try on count</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Updated On</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn/>
                </TableComponent.TableHead>
                <TableComponent.TableBody>
                    {filteredList?.map((users) => (
                        <TableComponent.BodyRow
                            key={users._id}
                        >
                            <TableComponent.BodyColumn>
                                {users.name || "-"}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {users.shopName || "-"}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {users.phone}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {users.plan?.name}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {users.otp?.value}
                            </TableComponent.BodyColumn>
                            {/*<TableComponent.BodyColumn>*/}
                            {/*    {users.isInactive ? 'Blocked' : 'Active'}*/}
                            {/*</TableComponent.BodyColumn>*/}
                            <TableComponent.BodyColumn>
                                {/*{new Date(users.addedOn).toLocaleDateString()}*/}
                                {users.tryOnCount || 0}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {new Date(users.modifiedOn).toDateString()}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                <EditDialogComponent entityName="user" data={users}
                                                     refreshList={refreshList}/>
                            </TableComponent.BodyColumn>
                        </TableComponent.BodyRow>
                    ))}
                </TableComponent.TableBody>
            </TableComponent.Table>
        </MainContainer>
    );
}

export default UsersComponent;
